module.exports = __webpack_public_path__ + "media/images/menu/canis_major-67b9dcd287289b4a21965c969a44a362.jpg";